import Command from "@ckeditor/ckeditor5-core/src/command"

export default class InsertArticleLinkBox extends Command {
  execute() {
    this.editor.model.change((writer) => {
      this.editor.model.insertContent(this.createArticleLinkBox(writer))
    })
  }

  refresh() {
    const model = this.editor.model
    const selection = model.document.selection
    const allowedIn = model.schema.findAllowedParent(
      selection.getFirstPosition(),
      "articleLinkBox"
    )

    this.isEnabled = allowedIn !== null
  }

  createArticleLinkBox(writer) {
    const box = writer.createElement("articleLinkBox")
    const label = writer.createElement("articleLinkBoxLabel")
    const excuse = writer.createElement("articleLinkBoxExcuse")
    const articleLink = writer.createElement("articleLinkBoxId")
    writer.append(label, box)
    writer.appendText("記事リンク", label)
    writer.append(articleLink, box)
    writer.append(excuse, box)
    writer.appendText(
      "※注意： 間違ったIDを入力すると、エラーにはなりませんが何も表示されません。",
      excuse
    )
    return box
  }
}
